import * as React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import { Facebook, Instagram, Twitter, LinkedIn } from "@mui/icons-material";
import { Box } from "@mui/material";

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: (theme) =>
          theme.palette.mode === "light"
            ? theme.palette.grey[200]
            : theme.palette.grey[800],
        p: 6,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={5}>
          <Grid item xs={12} sm={4}>
            <Typography variant="body2" color="text.secondary">
                <i>“Whatsoever thy hand findeth to do, do it with thy might”
                <br></br>
                -Ecclesiastes 9:10</i>
                <br></br>
            </Typography>
            <Typography variant="h6" color="text.primary">
            <b>
                ________________
                <br></br>
                Psi Delta Chapter
            </b>
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{fontSize:10.25}}>
            {"© "}
            {new Date().getFullYear()}
            &nbsp;Boston University Theta Tau
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} sx={{textAlign:'center'}}>
            <Typography variant="h6" color="text.primary">
              Executive Board
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Regent: James Decker
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Vice Regent: Sienna Chien 
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Treasurer: Aden Lok
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Secretary: Emily Dang
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Scribe: Audrey Wang
            </Typography>
          </Grid>
          <Grid item xs={12} sm={1}>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography variant="h6" color="text.primary" gutterBottom>
            Follow Us
            </Typography>
            <Link href="https://www.instagram.com/thetataubu/?hl=en" color="inherit">
              <Instagram />
            </Link>
            <Link href="https://www.linkedin.com/in/theta-tau-bu-psi-delta-chapter-395a82247/" color="inherit">
              <LinkedIn />
            </Link>
            <Link href="https://www.facebook.com/ThetaTauBU/" color="inherit">
              <Facebook />
            </Link>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}